import fr from './fr';
import en from './en';

export const languageList = {
    "en":en,
    "fr":fr
}
